export default {
	name: "add-or-edit-discount-group",
	props:{
		customerDiscountGroupId: {
			default: null
		}
	},
	data() {
		return {
			productsToLinkHeadings:[
				{
					text: "Product",
					field: "name"
				},
				// {
				// 	text: "Original Price",
				// 	field: "priceAsString"
				// },
				{
					text: "Discount Amount",
					field: "discountAmountAsString"
				},
				// {
				// 	text: "Price After Discount",
				// 	field: "priceAfterDiscountAsString"
				// }
			],
			companiesToLinkToDiscountGroupHeadings: [
				{
					text: "Name",
					field: "registeredCompanyName"
				},
				{
					text: "Company Registration Number",
					field: "companyRegistrationNumber"
				},
				{
					text: "VAT Number",
					field: "taxVatNumber"
				},
			],
			customerDiscountGroupAddEditForm:{
				customerDiscountGroup:{
					customerDiscountGroupId: null,
					isActive: true,
					name: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					discountAmount: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					linkedProducts:{
						value: [],
						hasError: false,
						errorMessage: null
					},
					unlinkedProducts:{
						value: [],
						hasError: false,
						errorMessage: null
					},
					linkedCustomers: {
						value: [],
						hasError: false,
						errorMessage: null
					},
					unlinkedCustomers: {
						value: [],
						hasError: false,
						errorMessage: null
					}
				}
			},
			linkProductsToDiscountGroupModal: {
				showModal: false,
				isSaving: false,
				modalId: "linkProductsToDiscountGroupModal",
				heading: "Link Products To Discount Group",
				customerDiscountGroupId: null
			},
			linkCustomersToDiscountGroupModal: {
				showModal: false,
				modalId: "linkCustomerToDiscountGroupModal",
				heading: "Link Customers To Discount Group",
				customerDiscountGroupId: null
			},
			errorModal:{
				modalHeading: "Error",
				elementId: "customerModalError",
				modalMessage: "",
				showModal: false
			},
			successModal:{
				modalHeading: "Success",
				elementId: "customerModalSuccess",
				modalMessage: "",
				showModal: false
			},
			loading: false,
			loadingFromApi: false,
			productIdThatWasUnlinked: null,
			companyIdThatWasUnlinked: null
		};
	},
	methods: {
		getDiscountGroup(){
			this.loading = true;
			orderService.getDiscountGroup(this.customerDiscountGroupId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.value = successResponse.data.result.discountAmount;
						this.customerDiscountGroupAddEditForm.customerDiscountGroup.name.value = successResponse.data.result.name;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onDiscountAmountChange(){
			if(this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.value !== null && this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount > 0){
				for(let i = 0; i < this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value.length; i++){
					this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value[i].discountAmount = this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.value;
					this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value[i].discountAmountAsString = currencyHelper.numberToCurrency(this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.value);
				}
			}
		},
		onBackClick() {
			this.$router.go(-1);
		},
		onLinkProductsClick(){
			this.linkProductsToDiscountGroupModal.showModal = true;
		},
		onProductUnlink(productId) {
			let product = this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value.find(product => product.productId === productId);
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value = this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value.filter(product => product.productId !== productId);
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.unlinkedProducts.value.push(product);
			this.productIdThatWasUnlinked = productId;
		},
		onProductsLinkedOrUnlinked(products) {
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value = products.productsToLink === null ? [] : JSON.parse(JSON.stringify(products.productsToLink));
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.unlinkedProducts.value = products.productsToUnlink === null ? [] : JSON.parse(JSON.stringify(products.productsToUnlink));
			if(products.isSaving){
				this.linkProductsToDiscountGroupModal.showModal = false;
			}
			console.log("linkedProducts", this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value);
		},
		onCustomersLink(){
			this.linkCustomersToDiscountGroupModal.showModal = true;
		},
		onCustomerUnlink(companyId){
			let company = this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedCustomers.value.find(company => company.companyId === companyId);
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedCustomers.value = this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedCustomers.value.filter(company => company.companyId !== companyId);
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.unlinkedCustomers.value.push(company);
			this.companyIdThatWasUnlinked = companyId;
		},
		onLinkProductsToCustomerGroupModalOkClick(){
			this.linkProductsToDiscountGroupModal.showModal = false;
		},
		onCustomersLinkedOrUnlinked(customers){
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedCustomers.value = JSON.parse(JSON.stringify(customers.customersToLink));
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.unlinkedCustomers.value = JSON.parse(JSON.stringify(customers.customersToUnlink));
			console.log("linkedCustomers", this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedCustomers.value);
			if(customers.isSaving){
				this.linkCustomersToDiscountGroupModal.showModal = false;
			}
			this.companyIdThatWasUnlinked = null;
		},
		onLinkCustomersToDiscountGroupModalOkClick(){
			this.linkCustomersToDiscountGroupModal.showModal = false;
			this.companyIdThatWasUnlinked = null;
		},
		errorModelOkClicked() {
			this.errorModal.showModal = false;
		},
		successModelOkClicked() {
			this.successModal.showModal = false;
			this.$router.go(-1);
		},
		addOrUpdateDiscountGroup(){
			this.loading = true;
			var productIdsToLink = [];
			var productIdsToUnlink = [];
			var companyIdsToLink = [];
			var companyIdsToUnlink = [];
			productIdsToLink = this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value.map(product => product.productId);
			productIdsToUnlink = this.customerDiscountGroupAddEditForm.customerDiscountGroup.unlinkedProducts.value.map(product => product.productId);
			companyIdsToLink = this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedCustomers.value.map(company => company.companyId);
			companyIdsToUnlink = this.customerDiscountGroupAddEditForm.customerDiscountGroup.unlinkedCustomers.value.map(company => company.companyId);
			let request ={
				discountGroupId: this.customerDiscountGroupAddEditForm.customerDiscountGroup.customerDiscountGroupId === null ? 0 : this.customerDiscountGroupAddEditForm.customerDiscountGroup.customerDiscountGroupId,
				name: this.customerDiscountGroupAddEditForm.customerDiscountGroup.name.value,
				discountAmount: this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.value === null ? 0 : this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.value,
				isActive: this.customerDiscountGroupAddEditForm.customerDiscountGroup.isActive,
				productIdsToLink: productIdsToLink,
				productIdsToUnlink: productIdsToUnlink,
				companyIdsToLink: companyIdsToLink,
				companyIdsToUnlink: companyIdsToUnlink
			};
			orderService.addOrUpdateDiscountGroup(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.discountGroupValidationResponse.valuesAreValid){
							this.successModal.modalMessage = "Discount Group has been saved successfully";
							this.successModal.showModal = true;
						}
						else{
							this.customerDiscountGroupAddEditForm.customerDiscountGroup.name.hasError = successResponse.data.discountGroupValidationResponse.nameValidationResponse.hasError;
							this.customerDiscountGroupAddEditForm.customerDiscountGroup.name.errorMessage = successResponse.data.discountGroupValidationResponse.nameValidationResponse.message;
							this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.hasError = successResponse.data.discountGroupValidationResponse.discountAmountValidationResponse.hasError;
							this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.errorMessage = successResponse.data.discountGroupValidationResponse.discountAmountValidationResponse.message;

							this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedCustomers.hasError = successResponse.data.discountGroupValidationResponse.companyIdsToLinkResponse.hasError;
							this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedCustomers.errorMessage = successResponse.data.discountGroupValidationResponse.companyIdsToLinkResponse.message;

							this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.hasError = successResponse.data.discountGroupValidationResponse.productIdsToLinkValidationResponse.hasError;
							this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.errorMessage = successResponse.data.discountGroupValidationResponse.productIdsToLinkValidationResponse.message;
						}
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		setBreadcrumbs() {
			var pageTitle = "Add Discount Group";
			if(this.customerDiscountGroupId != null && this.customerDiscountGroupId > 0){
				pageTitle = "Edit Discount Group";
			}
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		
	},
	watch:{
		customerDiscountGroupId:{
			handler: function () {
				if(this.customerDiscountGroupId !== null && this.customerDiscountGroupId > 0){
					this.getDiscountGroup();
				}
				this.setBreadcrumbs();
				this.customerDiscountGroupAddEditForm.customerDiscountGroup.customerDiscountGroupId = this.customerDiscountGroupId === null || this.customerDiscountGroupId === "" ? 0 : this.customerDiscountGroupId;
			},
			immediate: true,
			deep: true
		}
	}
};